/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Resetpassword1Inputs */



/**

* @param {_Login_Resetpassword1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_resetpassword1 = /** @type {((inputs?: _Login_Resetpassword1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Resetpassword1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kennwort zurücksetzen oder erstmalig ein neues Kennwort setzen")
});
export { _login_resetpassword1 as "_login_resetPassword" }